import PropTypes from 'prop-types';

const OEAnimateHelper = {

    animateTop(animate)   {
        return !animate ? false : (typeof(animate) === 'object' ? !!animate.top : !!animate);
    },

    animateRight(animate)   {
        return !animate ? false : (typeof(animate) === 'object' ? !!animate.right : !!animate);
    },

    animateBottom(animate)   {
        return !animate ? false : (typeof(animate) === 'object' ? !!animate.bottom : !!animate);
    },

    animateLeft(animate)   {
        return !animate ? false : (typeof(animate) === 'object' ? !!animate.left : !!animate);
    },

    animateAny(animate)   {
        return !animate ? false : (typeof(animate) === 'object' ? !!animate.top || !!animate.right || !!animate.bottom || !!animate.left : !!animate);
    },

    resolve(animate, fill = true)    {
        if(!animate)    return {top: false, right: false, bottom: false, left: false};

        if(typeof(animate) === 'object')    {
            if(fill)    return {top: !!animate.top, right: !!animate.right, bottom: !!animate.bottom, left: !!animate.left};
            
            let ret = {};
            if(animate.top !== undefined)       ret.top = !!animate.top;
            if(animate.right !== undefined)     ret.right = !!animate.right;
            if(animate.bottom !== undefined)    ret.bottom = !!animate.bottom;
            if(animate.left !== undefined)      ret.left = !!animate.left;
            return ret;
        } else {
            return {top: true, right: true, bottom: true, left: true}
        }
    },

    transitionForInsets(insets, duration, filter)    {
        if(!insets) return '';

        const dur = typeof(duration) === 'number' ? (duration.toString() + 's') : '0.333s';

        if(typeof(insets) === 'boolean')    {
            if(!filter) {
                return 'top ' + dur + ' ease, ' + 'right ' + dur + ' ease, ' + 'bottom ' + dur + ' ease, ' + 'left ' + dur + ' ease';
            }
            insets = {top: insets, right: insets, bottom: insets, left: insets};
        }

        let ret = '';
        if(insets.top && (!filter || filter.top))       ret += 'top ' + dur + ' ease';
        if(insets.right && (!filter || filter.right))   ret += (ret !== '' ? ', ' : '') + 'right ' + dur + ' ease';
        if(insets.bottom && (!filter || filter.bottom)) ret += (ret !== '' ? ', ' : '') + 'bottom ' + dur + ' ease';
        if(insets.left && (!filter || filter.left))     ret += (ret !== '' ? ', ' : '') + 'left ' + dur + ' ease';
        return ret;
    },

    merge(a, b) {
        if(!a && !b)    return false;
        if(typeof(a) === 'boolean' && typeof(b) === 'boolean')  return true;

        a = this.resolve(a);
        b = this.resolve(b);

        return {
            top: a.top || b.top,
            right: a.right || b.right,
            bottom: a.bottom || b.bottom,
            left: a.left || b.left
        };
    },

    update(dst, src, filter)    {
        if(!dst && !src)    return false;

        dst = this.resolve(dst);
        src = this.resolve(src, false);

        let ret = Object.assign({}, dst);
        if(!filter || filter.top)       ret.top = src.top !== undefined ? !!src.top : dst.top;
        if(!filter || filter.right)     ret.right = src.right !== undefined ? !!src.right : dst.right;
        if(!filter || filter.bottom)    ret.bottom = src.bottom !== undefined ? !!src.bottom : dst.bottom;
        if(!filter || filter.left)      ret.left = src.left !== undefined ? !!src.left : dst.left;

        return ret;
    },

    propDecl: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
        top: PropTypes.bool,
        right: PropTypes.bool,
        bottom: PropTypes.bool,
        left: PropTypes.bool
    })]),

    offsetEqual(u, v)   {
        if(!u && !v)    return true;
        if(!u || !v)    return false;
        return u.top == v.top && u.right == v.right && u.bottom == v.bottom && u.left == v.left;
    }
};

OEAnimateHelper.offsetDecl = PropTypes.shape({
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
    animate: OEAnimateHelper.propDecl
});

export default OEAnimateHelper;